module.exports = __webpack_public_path__ + "static/media/mini-keanu-reeves.e25372d9.jpg";